import { fetchAuth } from "../../../shared/api/ApiService";
import { IConvertTrialLessonToStudentRequest, IConvertTrialLessonToStudentResponse, ICreateTrialLessonRequest,
    IDeleteTrialLessonRequest, IFindTrialAvailableTutorsRequest, IFindTrialAvailableTutorsResponse, IGetTrialDayCalendarRequest,
    IGetTrialDayCalendarResponse, IGetTrialLessonResponse, IGetTrialMonthCalendarRequest, IGetTrialMonthCalendarResponse,
    IMarkTrialLessonLostRequest, IReopenLostTrialLessonRequest, IRescheduleTrialLessonRequest, ITrialCalendarFilter, ITrialLessonResponse,
    IUpdateTrialLessonRequest,
} from "../model/types";

export const getDefaultTrialCalendarFilter = (): ITrialCalendarFilter => ({
    tgAccountIds: [],
    userIds: [],
    tagIds: [],
    lostTypes: [],
    statuses: [
        'TRIAL_LESSON_STATUS_ASSIGNED',
        'TRIAL_LESSON_STATUS_COMPLETED',
        'TRIAL_LESSON_STATUS_STUDENT_CREATED',
        'TRIAL_LESSON_STATUS_LOST',
        'TRIAL_LESSON_STATUS_ORANGE_PENDING',
    ],
    tutorGender: 'TUTOR_GENDER_UNSPECIFIED',
    requiredDurationSlots: 1,
})

class TrialLessonService {
    async getTrialMonthCalendar(data: IGetTrialMonthCalendarRequest): Promise<IGetTrialMonthCalendarResponse> {
        const res = await fetchAuth(`${process.env.REACT_APP_SERVER_URL_ADMIN}/api/v1/trial-lessons/calendar/month`, {
            method: 'POST',
            body: JSON.stringify(data),
        })

        return await res.json()
    }

    async getTrialDayCalendar(data: IGetTrialDayCalendarRequest): Promise<IGetTrialDayCalendarResponse> {
        const res = await fetchAuth(`${process.env.REACT_APP_SERVER_URL_ADMIN}/api/v1/trial-lessons/calendar/day`, {
            method: 'POST',
            body: JSON.stringify(data),
        })

        return await res.json()
    }

    async createTrialLesson(data: ICreateTrialLessonRequest): Promise<ITrialLessonResponse> {
        const res = await fetchAuth(`${process.env.REACT_APP_SERVER_URL_ADMIN}/api/v1/trial-lessons`, {
            method: 'POST',
            body: JSON.stringify(data),
        })

        return await res.json()
    }

    async findTrialAvailableTutors(
        data: IFindTrialAvailableTutorsRequest,
        {signal}: {signal?: AbortSignal} = {},
    ): Promise<IFindTrialAvailableTutorsResponse> {
        const res = await fetchAuth(`${process.env.REACT_APP_SERVER_URL_ADMIN}/api/v1/trial-lessons_available_tutors`, {
            method: 'POST',
            body: JSON.stringify(data),
            signal,
        })

        return await res.json()
    }

    async getTrialLesson(trialLessonId: string): Promise<IGetTrialLessonResponse> {
        const res = await fetchAuth(`${process.env.REACT_APP_SERVER_URL_ADMIN}/api/v1/trial-lessons/${trialLessonId}`)

        return await res.json()
    }

    async completeTrialLesson(trialLessonId: string): Promise<ITrialLessonResponse> {
        const res = await fetchAuth(`${process.env.REACT_APP_SERVER_URL_ADMIN}/api/v1/trial-lessons/${trialLessonId}/complete`, {
            method: 'POST',
        })

        return await res.json()
    }

    async markTrialLessonLost(data: IMarkTrialLessonLostRequest): Promise<ITrialLessonResponse> {
        const res = await fetchAuth(`${process.env.REACT_APP_SERVER_URL_ADMIN}/api/v1/trial-lessons/${data.trialLessonId}/lost`, {
            method: 'POST',
            body: JSON.stringify(data),
        })

        return await res.json()
    }

    async reopenLostTrialLesson(data: IReopenLostTrialLessonRequest): Promise<ITrialLessonResponse> {
        const res = await fetchAuth(`${process.env.REACT_APP_SERVER_URL_ADMIN}/api/v1/trial-lessons/${data.trialLessonId}/reopen-lost`, {
            method: 'POST',
            body: JSON.stringify(data),
        })

        return await res.json()
    }

    async rescheduleTrialLesson(data: IRescheduleTrialLessonRequest): Promise<ITrialLessonResponse> {
        const res = await fetchAuth(`${process.env.REACT_APP_SERVER_URL_ADMIN}/api/v1/trial-lessons/${data.trialLessonId}/reschedule`, {
            method: 'POST',
            body: JSON.stringify(data),
        })

        return await res.json()
    }

    async updateTrialLesson(data: IUpdateTrialLessonRequest): Promise<ITrialLessonResponse> {
        const res = await fetchAuth(`${process.env.REACT_APP_SERVER_URL_ADMIN}/api/v1/trial-lessons/${data.trialLessonId}`, {
            method: 'POST',
            body: JSON.stringify(data),
        })

        return await res.json()
    }

    async convertTrialLessonToStudent(data: IConvertTrialLessonToStudentRequest): Promise<IConvertTrialLessonToStudentResponse> {
        const res = await fetchAuth(`${process.env.REACT_APP_SERVER_URL_ADMIN}/api/v1/trial-lessons/${data.trialLessonId}/convert-to-student`, {
            method: 'POST',
            body: JSON.stringify(data),
        })

        return await res.json()
    }

    async deleteTrialLesson(data: IDeleteTrialLessonRequest): Promise<void> {
        await fetchAuth(`${process.env.REACT_APP_SERVER_URL_ADMIN}/api/v1/trial-lessons/${data.trialLessonId}/delete`, {
            method: 'POST',
            body: JSON.stringify(data),
        })
    }
}

export const trialLessonService = new TrialLessonService()
